// extracted by mini-css-extract-plugin
module.exports = {"logo":"_xuio8T7d","badge":"_lnH6ulZR"};